import { API_JWT_BASE_URL } from '../http'

export const SEARCH_AUDIT_LOGS_API = `${API_JWT_BASE_URL}/AuditLogs`
export const EXPORT_AUDIT_LOGS_API = `${API_JWT_BASE_URL}/AuditLogs/export`

export const AUDIT_LOGS_QUERY_KEYS = {
  SEARCH_AUDIT_LOGS: 'SEARCH_AUDIT_LOGS',
  EXPORT_AUDIT_LOGS: 'EXPORT_AUDIT_LOGS'
}
